import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router,  ActivatedRoute  } from '@angular/router';
import { AlertifyService } from '@services/alertify.service';
import { AuthService } from '@services/auth.service';
import { UserDto } from '@models/user-dto';
import { UserClassesService } from '@services/user-classes.service';
import { UserService } from '@services/user.service';
import { CustomValidators } from '@app/shared/validators/custom.validators';
import { TranslateService } from '@ngx-translate/core';
import { Bootstrap_Modal_Service } from '@services/bootstrap-modal.service';

@Component({
  selector: 'change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  model: any = {};
  changePasswordForm: FormGroup;
  processing: boolean;
  email: string;
  token: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private userService: UserService,
    public authService: AuthService,
    private alertify: AlertifyService,
    private actRoute: ActivatedRoute,
    private userClassesService: UserClassesService,
    private translate: TranslateService,
    private bootstrap_modal: Bootstrap_Modal_Service
  ) { }

    /*
  ngOnInit() {
    this.createLoginForm();

    this.processing = true;
    if (this.authService.loggedIn()) {
      this.router.navigate(['/home']); 
    }

  }
  */
  ngOnInit() {
    this.createResetForm();
    this.email = this.actRoute.snapshot.params['email'];
    //this.token = this.actRoute.snapshot.params['token'];
  }

  getUrl() {
    return "url('assets/sky8.jpg')";
  }
  //Assigns values to the form
  createResetForm() {
    this.changePasswordForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', [Validators.required]],
      newpassword: ['', [Validators.required]],
      confirmnewpassword: ['', [Validators.required]]
    });
  }

  /*
  resetUserPassword() {
    this.model = Object.assign({}, this.changePasswordForm.value);

    this.authService.changePassword(this.model).subscribe(next => {
      //this.alertify.success('Your password had been changed successfully.');
      // tslint:disable-next-line:no-shadowed-variable
    }, error => {
      //this.alertify.error(error); //  'Failed to loginsss');
    }, () => {
        this.router.navigate(['/login']);
    }
    );
  }
  */
  resetUserPassword() {
    this.model = Object.assign({}, this.changePasswordForm.value);
  
    this.authService.changePassword(this.model).subscribe(next => {

      this.translate.get(["ALERTIFY.CHANGE_PASSWORD_SUCCESSFUL", "BOOTSTRAP.MODAL.SUCCESS"]).subscribe((text: string) => {
        this.alertify.success(text);

        this.bootstrap_modal.open({
          modal_header_html: text['BOOTSTRAP.MODAL.SUCCESS'],
          modal_body_html: text['ALERTIFY.CHANGE_PASSWORD_SUCCESSFUL'],
          modal_color_variant: "success"
        })
      })

      // tslint:disable-next-line:no-shadowed-variable
    }, error => {
      console.error(error)
      this.translate.get(["ALERTIFY.CHANGE_PASSWORD_FAILED", "BOOTSTRAP.MODAL.ERROR"]).subscribe((text: string) => {
        this.alertify.error(error)

        this.bootstrap_modal.open({
          modal_header_html: text['BOOTSTRAP.MODAL.ERROR'],
          modal_body_html: text['ALERTIFY.CHANGE_PASSWORD_FAILED'],
          modal_color_variant: "success"
        })
      });
    }, () => {
        this.router.navigate(['/login']);
    })
  }

  register() {
    this.router.navigate(['/register']);
  }

}
